<yat-error-outlet id="2912899c-175d-4442-b46b-1fcad83e883e" [errorSpecification]="(errorSpecification$ | async) ?? undefined"> </yat-error-outlet>
